import { MentionCommandMenu, MentionOption } from "./command-menu";
import { addComposerChild$, addNestedEditorChild$, realmPlugin } from '@mdxeditor/editor';

export type MentionPluginParameters = {
    options: MentionOption[];
}

export const mentionShortcutPlugin = realmPlugin<MentionPluginParameters>({
    init(realm, params) {
        realm.pubIn({
            [addComposerChild$]: () => (
                <>
                    <MentionCommandMenu options={params.options} />
                </>
            ),
            [addNestedEditorChild$]: () => (
                <>
                    <MentionCommandMenu options={params.options} />
                </>
            ),
        });
    },
});